import { render } from "./ContactCard.vue?vue&type=template&id=add9744c&scoped=true"
import script from "./ContactCard.vue?vue&type=script&lang=js"
export * from "./ContactCard.vue?vue&type=script&lang=js"

import "./ContactCard.vue?vue&type=style&index=0&id=add9744c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-add9744c"]])

export default __exports__